export default __webpack_public_path__ + "static/media/pin_green.e63a17fb.svg";